import { getUrl, getHeaders } from '~/utils/urlHelpers'

export const fetchAllData = (language: string, label: string, hostname: string) => {
  const runtimeConfig = useRuntimeConfig();
  const { $apiMethods } = useNuxtApp() as unknown as {$apiMethods: { getApiHostUrl: () => string }}
  const { isIntranet } = useIntranetAuth()

  const data = useFetch(
    getUrl(language, label, hostname, runtimeConfig.public, $apiMethods.getApiHostUrl(), isIntranet()),
    {
      headers: getHeaders(),
    }
  );

  return data
}